// The circle tile (07, Design A; v1.58.37): the rail's first item and the phone Circle tab's; a
// button that opens Your circles (src/accounts/YourCircles.tsx). Its name is only its tooltip.
import type { MatrixClient } from 'matrix-js-sdk';
import type { CSSProperties } from 'react';
import { circleName, circlePicture } from '../accounts/accounts';
import { openCircles, useCirclesOpen } from '../accounts/YourCircles';
import { Picture } from '../blocks/Bits';
import { useTooltip } from '../blocks/Button';
import { Icon } from '../blocks/icons';
import { idColour, initial } from '../core/format';
import { serverOf } from '../core/session';
import { t } from '../i18n';
import { frameIcons } from './icons';

export const colourOf = (userId: string) => `var(--name-${idColour(serverOf(userId))})`;

/** A circle's face: its picture (cover), else the 140° gradient of its colour with its two initials. */
export const CircleFace = ({ userId, size, radius = Math.round(size / 3.2) }: { userId: string; size: number; radius?: number }) => (
  <span className="circle-face" style={{ '--circle-c': colourOf(userId), width: size, height: size, borderRadius: radius, fontSize: (size * 19) / 52 } as CSSProperties}>
    <Picture src={circlePicture(userId)} alt="" fallback={initial(circleName(userId), 2)} fade />
  </span>
);

/** The rail's (44 px, 13 px corners) or the phone Circle tab's (56 px, 16 px corners) circle tile. */
export function CircleTile({ client, size }: { client: MatrixClient; size: 44 | 56 }) {
  const me = client.getUserId()!;
  const open = useCirclesOpen();
  const rail = size === 44;
  const { triggerProps, tooltip } = useTooltip(circleName(me), 'right');
  return (
    <>
      <button
        type="button"
        className={rail ? 'circle-tile' : 'circle-tile on-page'}
        style={{ '--circle-c': colourOf(me) } as CSSProperties}
        data-desyr-circle-tile={serverOf(me)}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label={t('circles.tile', { circle: circleName(me) })}
        onClick={(e) => openCircles(e.currentTarget)}
        {...(rail ? triggerProps : {})}
      >
        <CircleFace userId={me} size={size} radius={rail ? 13 : 16} />
        <span className="circle-badge" aria-hidden="true"><Icon svg={frameIcons.expandMore} size={rail ? 10 : 12} /></span>
      </button>
      {rail && !open && tooltip}
    </>
  );
}
